import React from 'react';
import { connect } from 'react-redux';
import { Mixpanel } from '../../redux/Mixpanel';
import _ from 'lodash';

import {
    Row,
    Col,
    Input,
    Label,
    FormGroup,
    FormFeedback,
    UncontrolledTooltip,
    Form
} from 'reactstrap';

import { Card } from '@tremor/react';

import { OCCUPANT_TYPE, PAYBILL, TILL_NUMBER} from '../../utils/constants';
import UploadFile from '../Forms/UploadFile';
import { check_if_number, check_mpesa_shortcodes_length } from '../Forms/validationChecks';
import { colorTheme } from '../../utils/constants';
import {
    fetchSettings,
    updateSettings,
    fetchOptions,
    showLoading,
    downloadFile,
    fetchDashboardSummary,
    showCustomMessage
} from '../../redux/actions';

import fileDownload from 'js-file-download';

import CurrencyDropdown from '../../components/CustomerCurrencySelect';

import Timezone from '../../components/TimeZone';
import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonLabel, IonMenuButton, IonPage, IonRadio, IonRadioGroup, IonSelect, IonSelectOption, IonTitle, IonToolbar } from '@ionic/react';
import { Capacitor } from '@capacitor/core';
import { alertCircleOutline } from 'ionicons/icons';


const mapStateToProps = state => {
    return {
        settings: state.settings,
        options: state.options
    };
}

const mapDispatchToProps = {
    fetchDashboardSummary,
    fetchSettings,
    updateSettings,
    fetchOptions,
    showLoading,
    downloadFile,
    showCustomMessage
}

class GeneralSettings extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            companyName: "",
            companyShortName: "",
            mpesaShortcode: "",
            address: "",
            logoFileId: "",
            updateLogo: false,
            logoFile: null,
            logoFileName: "",
            letterheadFileId: "",
            updateLetterhead: false,
            letterheadFile: null,
            letterheadFileName: "",
            mpesaShortcodeTypes: [PAYBILL, TILL_NUMBER],
            mpesaShortcodeType: PAYBILL, // or TILL_NUMBER or paybill
            tillNumber: "",
            paybillAccountNumber: "",
            validateMpesaPayments: true,
            includeInMessages:false,
            autoGenerateRentInvoices: false,
            autoGenerateOtherRecurringInvoices: false,
            alertLandlordNewTenant: false,
            tenantPaymentReminderDates: {},
            leaseSmsAlertDays: [],
            leaseExpiryReminderDays: [],
            accountType: "",
            messageTypes: [],
            invoiceTitle: "",
            invoiceFootnote: "",
            errors : {
                mpesaShortcode: "",
                tillNumber: "",
                paybillAccountNumber: "",
                autoGenerateRentInvoices: "",
                autoGenerateOtherRecurringInvoices: "",
                alertLandlordNewTenant: "",
            }
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRadioButtons = this.handleRadioButtons.bind(this);
    }

    async fetchInitialData() {
        await Promise.all([
            (
                async () => {
                    if (_.isEmpty(this.props.options)) {
                        this.props.showLoading(true);
                        this.props.fetchOptions();
                    }
                }
            )(),
            (
                async () => {
                    if (_.isEmpty(this.props.settings)) {
                        this.props.showLoading(true);
                        await this.props.fetchSettings();
                    }
                }
            )()
        ]);
    }

    async componentDidMount() {
        await this.fetchInitialData();

        const leaseExpiryReminderDays = this.props.options.leaseExpiryReminderDays;

        const { settings, options } = this.props;

        this.setState(
            {
              companyName: settings.companyName,
              companyShortName: settings.companyShortName,
              includeInMessages: settings.includeInMessages,
              address: settings.address,
              logoFileId: settings.logoFileId,
              logoFileName: settings.logoFileName,
              letteheadFileId: settings.letteheadFileId,
              letteheadFileName: settings.letteheadFileName,
              mpesaShortcode: settings?.mpesa.shortcode,
              mpesaShortcodeType: settings.mpesa.shortcodeType, // or TILL_NUMBER or paybill
              tillNumber: settings.mpesa.tillNumber,
              paybillAccountNumber: settings.mpesa.defaultAccountNumber,
              validateMpesaPayments: settings.mpesa.validatePayments,
              autoGenerateRentInvoices: settings.automatedTasks.autoGenerateRentInvoices,
              autoGenerateOtherRecurringInvoices: settings.automatedTasks.autoGenerateOtherRecurringInvoices,
              alertLandlordNewTenant: settings.automatedTasks.alertLandlordNewTenant,
              tenantPaymentReminderDates: settings.automatedTasks.tenantPaymentReminderDates,
              leaseSmsAlertDays: settings.automatedTasks.leaseSmsAlertDays,
              messageTypes: settings.automatedTasks.messageTypes,
              leaseExpiryReminderDays,
              accountType: options.userAccountType || "",
              invoiceTitle: settings.invoiceTitle ?? "",
              invoiceFootnote: settings.invoiceFootnote ?? ""
            }

        )

        // Mixpanel.track("General settings: mounted");
    }


    handleChange(event) {
        const target = event.target;
        let name = target.name;
        let val = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({[name]: val});

        this.validateInput(name, val);

    }

    validateInput(name, value){
        let val = String(value);
        let isValid = true;
        let errors = this.state.errors;
        let checks = [];
        switch(name){
            case "mpesaShortcode":
                checks = [check_if_number, check_mpesa_shortcodes_length];
                break;
            case "tillNumber":
                checks = [check_if_number, check_mpesa_shortcodes_length];
                break;
            case  "paybillAccountNumber":
                checks = [() => ""]
            default:
                break;
        }
        for (let index in checks){
            let previousError = errors[name];
            errors[name] = checks[index](val);
            if (errors[name].length > 0){
                if (previousError.length == 0){
                    this.setState((prevState)=>({numErrors: prevState.numErrors + 1}));
                }
                isValid = false;
                break;
            }else if(previousError.length > 0){
                this.setState((prevState)=>({numErrors: prevState.numErrors - 1}));
            }
        }
        return isValid;
    }

    getShortcodeType(){
        // only sends shortcode types(paybill or till number) to the backend if the fields are number fields are not empty.
        let shortcodeType = "";
        if (this.state.mpesaShortcodeType===PAYBILL && this.state.mpesaShortcode){
            shortcodeType = PAYBILL;
        } else if(this.state.mpesaShortcodeType===TILL_NUMBER && (this.state.mpesaShortcode || this.state.tillNumber)){
            shortcodeType = TILL_NUMBER;
        }
        return shortcodeType
    }

    handleDownloadFile(fileName, fileId, file){
        if (fileName && fileId){
            this.props.showLoading(true);
            this.props.downloadFile({
                itemType: "company",
                fileId,
                fileName
            });
            Mixpanel.track("form: download file company");
        }else if(file){
            fileDownload(file, file.name);
        }
    }

    handleChangeLogoFile(event){
        this.setState({
            logoFileId: "",
            updateLogo: true,
            logoFile: event.target.files[0],
            logoFileName: event.target.files[0].name
        });
    }

    sendRemindersSettingToList(){
        let list = []
        for (let date of this.state.tenantPaymentReminderDates){
            date.value && list.push(this.removeLettersFromLabelDates(date.label))
        }
        return list
    }

    removeLettersFromLabelDates(dateString){
        let letters = ['st', 'rd', 'th'];
        let newDateString = "";
        for (let l of letters){
            if (dateString.includes(l)){
                newDateString = dateString.replace(l, '')
            }
        }
        return newDateString;
    }

    handleCloseLogo(){
        this.setState({updateLogo: true, logoFileId: "", logoFile: null, logoFileName: ""});
    }

    handleChangeLetterheadFile(event){
        this.setState({
            letterheadFileId: "",
            updateLetterhead: true,
            letterheadFile: event.target.files[0],
            letterheadFileName: event.target.files[0].name
        });
    }

    handleCloseLetterhead(){
        this.setState({
            updateLetterhead: true, letterheadFileId: "",
            letterheadFile: null, letterheadFileName: ""
        });
    }


    async handleSubmit(event){
        event.preventDefault();
        let fields = ["companyName", "companyShortName", "mpesaShortcode", "tillNumber"];
        let results = [];
        for(let field of fields){
            let isValid = await this.validateInput(field, this.state[field])
            results.push(isValid);
        }
        let invalid_fields = results.filter( (x) => !x);

        // Validate that at least one message type is selected
        if (this.state.messageTypes.length === 0) {
            this.props.showCustomMessage('', 'Please select at least one communication method.');
            return;
        }

        if (invalid_fields.length == 0){
            this.props.showLoading(true);
            const action = await this.props.updateSettings({
                companyName: this.state.companyName,
                companyShortName: this.state.companyShortName,
                includeInMessages: this.state.includeInMessages,
                mpesaShortcode: this.state.mpesaShortcode,
                mpesaShortcodeType: this.state.mpesaShortcodeType,
                tillNumber: this.state.tillNumber,
                address: this.state.address,
                logo: this.state.logoFile,
                updateLogo: this.state.updateLogo,
                letterhead: this.state.letterheadFile,
                updateLetterhead: this.state.updateLetterhead,
                defaultAccountNumber: this.state.paybillAccountNumber,
                validatePayments: this.state.validateMpesaPayments,
                autoGenerateRentInvoices: this.state.autoGenerateRentInvoices,
                autoGenerateOtherRecurringInvoices: this.state.autoGenerateOtherRecurringInvoices,
                alertLandlordNewTenant: this.state.alertLandlordNewTenant,
                leaseSmsAlertDays: this.state.leaseSmsAlertDays,
                tenantPaymentReminderDates: this.sendRemindersSettingToList(),
                accountType: this.state.accountType,
                messageTypes: this.state.messageTypes,
                invoiceTitle: this.state.invoiceTitle,
                invoiceFootnote: this.state.invoiceFootnote
            });
            //refetch the dashboard summary if the leaseSmsAlertDays has changed
            let param = {propertyIds:""}
            this.props.fetchDashboardSummary(param);
            this.props.fetchOptions();
            this.props.showLoading(false);

            if (action.errorCode == "paybill_account_number"){
                await this.setState((prevState)=>({
                    ...prevState,
                    errors: {
                        ...prevState.errors,
                        paybillAccountNumber: action.errors,
                    },
                }));
            } else if(action.errorCode == "update_customer_account_settings_failed"){
                await this.setState((prevState)=>({
                    ...prevState,
                    errors: {
                        ...prevState.errors,
                        autoGenerateRentInvoices: action.errors,
                        autoGenerateOtherRecurringInvoices: action.errors,
                        alertLandlordNewTenant: action.errors,
                    },
                }));
            }
        }

    }

    handleSelectLeaseExpiryReminderDays(value){
        this.setState({leaseSmsAlertDays: [value]});
    }

    handleRadioButtons(event){
        const value = typeof event === 'object' ? event.target.value : event;

        const newState = { mpesaShortcodeType: value };
        if (value === TILL_NUMBER) {
            newState.paybillAccountNumber = "";
            newState.validateMpesaPayments = false;
            newState.mpesaShortcode = "";
        } else if (value === PAYBILL) {
            newState.tillNumber = "";
        }
        this.setState(newState);
    }

    renderMpesaSettings(){
        const tillTooltip = 'The store number given by Mpesa when you were given the Till Number';
        const paybillTooltip = 'Your MPESA paybill number';
        const shortcodeLabel = this.state.mpesaShortcodeType === TILL_NUMBER ? "Store Number" : "Paybill Number";

        return (<div className='mx-2'>
            <FormGroup className=""  row >
                <IonRadioGroup value={this.state.mpesaShortcodeType} onIonChange={this.handleRadioButtons}>
                    <IonLabel className='mr-2'>Paybill</IonLabel>
                    <IonRadio slot="start" value={PAYBILL} />
                    <IonLabel className='mx-2'>Till Number</IonLabel>
                    <IonRadio slot="start" value={TILL_NUMBER} />
                </IonRadioGroup>
            </FormGroup>

            <Col>
                <Row  className="my-1 ">
                    <Col className="my-1" lg={6}>
                        <Label for="mpesaShortcode">
                            {shortcodeLabel}
                        </Label>
                        <i id="mpesaShortcodeTooltip" className="fa fa-fw fa-info-circle ml-2"></i>
                        <Input
                            id="mpesaShortcode"
                            name="mpesaShortcode"
                            type="text"
                            onChange={this.handleChange}
                            value={this.state.mpesaShortcode}
                            placeholder={`${shortcodeLabel} ...`}
                        />
                        <FormFeedback>{this.state.errors.mpesaShortcode}</FormFeedback>

                        <UncontrolledTooltip placement="top" target="mpesaShortcodeTooltip">
                            {this.state.mpesaShortcodeType === TILL_NUMBER ? tillTooltip : paybillTooltip}
                        </UncontrolledTooltip>

                    </Col>

                    {this.state.mpesaShortcodeType === TILL_NUMBER && (<Col className="my-1" lg={6}>
                    <FormGroup>
                        <Label for="TillNumber" >
                            MPESA Till Number
                        </Label>
                        <Input
                            id="tillNumber"
                            name="tillNumber"
                            placeholder='Till Number ...'
                            value={this.state.tillNumber}
                            onChange={this.handleChange}
                            invalid={this.state.errors.tillNumber.length > 0}
                        />
                        <FormFeedback>{this.state.errors.tillNumber}</FormFeedback>
                        </FormGroup></Col>)}

                    {this.state.mpesaShortcodeType == PAYBILL && (<Col className="my-1" lg={6}>
                        <Label for="paybillAccountNumber">
                            Paybill Default Account #
                        </Label>
                        <i id="payBillAccountNumberTooltip" className="fa fa-fw fa-info-circle ml-2"></i>
                        <UncontrolledTooltip placement="top" target="payBillAccountNumberTooltip">
                            Default Account Number when paying using a paybill
                        </UncontrolledTooltip>

                        <Input
                            type="text"
                            name="paybillAccountNumber"
                            id="paybillAccountNumber"
                            value={this.state.paybillAccountNumber}
                            onChange={this.handleChange}
                            placeholder="Default Account Number..."
                            invalid={this.state.errors.paybillAccountNumber.length > 0}
                        />
                        <FormFeedback>{this.state.errors.paybillAccountNumber}</FormFeedback>
                    </Col>)}
                </Row>

                {this.state.mpesaShortcodeType == PAYBILL && (<Row className="ml-1 mt-1">
                    <FormGroup check>
                        <Label check>
                            <Input
                                type="checkbox"
                                name="validateMpesaPayments"
                                onChange={this.handleChange}
                                checked={this.state.validateMpesaPayments}
                            />{' '}
                            Validate Payments
                        </Label>
                    </FormGroup>
                </Row>)}
            </Col>
        </div>);
    }

    renderCompanySettings(){
        return (
            <div className='mx-2'>
                <FormGroup  className="" row>
                    <IonLabel for="companyName" sm={12} >
                        Company Name
                    </IonLabel>
                    <Col sm={12}>
                        <Input
                            type="text"
                            name="companyName"
                            id="companyName"
                            onChange={this.handleChange}
                            placeholder="Company Name..."
                            value={this.state.companyName}
                        />
                    </Col>
                </FormGroup>

                <FormGroup  className="" row>
                    <Label for="abbrevName" sm={12} >
                        Abbreviated Name
                    </Label>
                    <Col sm={12}>
                        <Input
                            type="text"
                            name="companyShortName"
                            id="abbrevName"
                            onChange={this.handleChange}
                            placeholder="Abbreviated Name ..."
                            value={this.state.companyShortName}
                        />
                    </Col>
                </FormGroup>

            {this.state.companyName != "" && (<Row className="mx-1 mt-2">
                    <FormGroup className="ml-2 mt-1" check>
                        {/* <i id="includeInMessagestooltip" className="fa fa-fw fa-info-circle ml-2"></i> */}
                        <Label check>
                            <Input
                                type="checkbox"
                                name="includeInMessages"
                                onChange={this.handleChange}
                                checked={this.state.includeInMessages}
                            />{' '}
                            Include Company name in Messages <i id="includeInMessagestooltip" className="fa fa-fw fa-info-circle ml-2"></i>
                        </Label>
                        <UncontrolledTooltip placement="top" target="includeInMessagestooltip">
                            Include the name of your company in messages sent to {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenants" : "members"}.
                        </UncontrolledTooltip>
                    </FormGroup>
                </Row>)}

                {/* Address */}
                <FormGroup  className="" row>
                    <Label for="companyName" sm={12} >
                        Company Address (optional)
                    </Label>
                    <Col sm={12}>
                        <Input
                            type="textarea"
                            name="address"
                            id="address"
                            onChange={this.handleChange}
                            placeholder="Company Address..."
                            value={this.state.address}
                        />
                    </Col>
                </FormGroup>

                {/* Logo */}
                { Capacitor.getPlatform() == "web" && (<FormGroup  className=" mt-3 " row>
                    <Label for="companyName" sm={12} >
                        Logo (Optional)
                    </Label>
                    <Col sm={12}>
                        <UploadFile
                            fileName={this.state.logoFileName}
                            file={this.state.logoFile}
                            noShowLabel={true}
                            label={"Logo upload (optional"}
                            handleDownloadFile={(event) => {
                                this.handleDownloadFile(this.state.logoFileName, this.state.logoFileId, this.state.logoFile)
                            }}
                            handleChangeFile={this.handleChangeLogoFile.bind(this)}
                            handleClose={this.handleCloseLogo.bind(this)}
                        />
                    </Col>
                </FormGroup>)}

                {/* Invoice document title and footnote */}
                <FormGroup className="mt-3" row>
                    <Label for="invoiceTitle" sm={12}>
                        Title of Invoice (optional)
                        <i id="invoiceTitleTooltip" className="fa fa-fw fa-info-circle ml-2"></i>
                    </Label>
                    <UncontrolledTooltip placement="top" target="invoiceTitleTooltip">
                        This will be shown at the top of every invoice you generate. Examples: Invoice, Bill, Proforma Invoice, Tax Invoice. Leave empty to use the default.
                    </UncontrolledTooltip>
                    <Col sm={12}>
                        <Input
                            type="text"
                            name="invoiceTitle"
                            id="invoiceTitle"
                            onChange={this.handleChange}
                            value={this.state.invoiceTitle}
                            placeholder="e.g. Invoice, Bill, Proforma Invoice"
                        />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="invoiceFootnote" sm={12}>
                        Invoice Footnote (optional)
                        <i id="invoiceFootnoteTooltip" className="fa fa-fw fa-info-circle ml-2"></i>
                    </Label>
                    <UncontrolledTooltip placement="top" target="invoiceFootnoteTooltip">
                        Optional text shown below the standard invoice footer (e.g. &quot;This is a non-tax invoice&quot;). Leave empty if not needed.
                    </UncontrolledTooltip>
                    <Col sm={12}>
                        <Input
                            type="textarea"
                            name="invoiceFootnote"
                            id="invoiceFootnote"
                            rows={3}
                            onChange={this.handleChange}
                            value={this.state.invoiceFootnote}
                            placeholder="e.g. This is a non-tax invoice. Leave empty for no footnote."
                        />
                    </Col>
                </FormGroup>
        </div>
        );
    }

    renderAutomatedTasksSettings(){
        return (
            <div>

                <FormGroup className="ml-2 mt-1" check>
                    <Label check>
                        <Input
                            type="checkbox"
                            id="autoGenerateRentInvoices"
                            name="autoGenerateRentInvoices"
                            onChange={this.handleChange}
                            checked={this.state.autoGenerateRentInvoices}
                        />{' '}
                        Automatically generate rent invoices <i id="autoGenerateRentInvoicestooltip" className="fa fa-fw fa-info-circle ml-2"></i>
                    </Label>
                    <UncontrolledTooltip placement="top" target="autoGenerateRentInvoicestooltip">
                        Automatically create rent invoices(bills) for each {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} at the start of the month.
                    </UncontrolledTooltip>
                </FormGroup>
                <FormFeedback>{this.state.errors.autoGenerateRentInvoices}</FormFeedback>

            </div>
        );
    }

    renderOtherRecurringAutomatedTasksSettings(){
        return (
            <div>

                <FormGroup className="ml-2 mt-1" check>
                    <Label check>
                        <Input
                            type="checkbox"
                            id="autoGenerateOtherRecurringInvoices"
                            name="autoGenerateOtherRecurringInvoices"
                            onChange={this.handleChange}
                            checked={this.state.autoGenerateOtherRecurringInvoices}
                        />{' '}
                        Automatically generate other recurring bills invoices <i id="autoGenerateOtherRecurringInvoicesToolTip" className="fa fa-fw fa-info-circle ml-2"></i>
                    </Label>
                    <UncontrolledTooltip placement="top" target="autoGenerateOtherRecurringInvoicesToolTip">
                     Automatically generate other recurring bills invoices for each unit at the start of the month.
                    </UncontrolledTooltip>
                </FormGroup>
                <FormFeedback>{this.state.errors.autoGenerateOtherRecurringInvoices}</FormFeedback>

            </div>
        );
    }

    renderLandlordAutomatedTasksSettings(){
        return (
            <div>

                <FormGroup className="ml-2 mt-1" check>
                    <Label check>
                        <Input
                            type="checkbox"
                            id="alertLandlordNewTenant"
                            name="alertLandlordNewTenant"
                            onChange={this.handleChange}
                            checked={this.state.alertLandlordNewTenant}
                        />{' '}
                        Alert landlord when new {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} is added to their property <i id="alertLandlordNewTenantToolTip" className="fa fa-fw fa-info-circle ml-2"></i>
                    </Label>
                    <UncontrolledTooltip placement="top" target="alertLandlordNewTenantToolTip">
                     Automatically alert landlord(s) when a new {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} is added to a unit in their property
                    </UncontrolledTooltip>
                </FormGroup>
                <FormFeedback>{this.state.errors.alertLandlordNewTenant}</FormFeedback>

            </div>
        );
    }

    renderSendPaymentRemindersAlerts(){
        return (
            <Col lg={12}>
                <Label for="paymentReminders" className='font-weight-normal ml-2 mb-2'>
                    Choose date(s) to remind {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenants" : "members"}
                </Label>
                <Col>
                    {!_.isEmpty(this.props.settings) && _.map(Object.values(this.state.tenantPaymentReminderDates), (preference, index) => (
                        <Col key={(preference.label)} className="" lg={1}>
                            <Input
                                type="checkbox"
                                className='mx-2'
                                id={preference.label}
                                name={preference.label}
                                checked={preference.value}
                                onChange={() => {
                                    this.setState((prevState) => {
                                        let oldTenantPaymentReminderDates =  [ ...prevState.tenantPaymentReminderDates ];
                                        oldTenantPaymentReminderDates[index] = {
                                            ...oldTenantPaymentReminderDates[index],
                                            value: !preference.value
                                        };
                                        return ({
                                            ...prevState,
                                            tenantPaymentReminderDates: oldTenantPaymentReminderDates
                                        })
                                    })
                                }}
                                data-testid={`reminders-${preference.label}`}
                            />
                            <Label for={`paymentReminders${preference.label}`}>
                                {preference.label}
                            </Label>
                        </Col>
                    ))}
                </Col>
            </Col>
        )
    }

    renderSendLeaseExpiryRemindersAlerts(){
        return (
            <div>
                {/* create dropdown so users select within what date range they want to receive alerts */}
                {/* Dropdown for selecting alert range */}
                <IonLabel position="stacked" htmlFor="alertRange">
                        Receive message and dashboard alerts for leases expiring within this range:
                    </IonLabel>
                <IonItem className="mt-1">

                    <IonSelect
                        fill='solid'
                        interface='action-sheet'
                        name="alertRange"
                        id="alertRange"
                        value={this.state.leaseSmsAlertDays}
                        onIonChange={(e) => this.handleSelectLeaseExpiryReminderDays(e.detail.value)}
                    >
                        <IonSelectOption value="">Select range...</IonSelectOption>
                        <IonSelectOption value="">No alerts</IonSelectOption>
                        {this.state.leaseExpiryReminderDays.map((day, index) => (
                            <IonSelectOption key={index} value={day}>Expiring in {day} days</IonSelectOption>
                        ))}
                    </IonSelect>
                </IonItem>

            </div>
        )
    }

    renderCommunicationOptions(){
        const { allMessageTypes = [] } = this.props.options || {};

        return (
            <div className='mx-2'>
                <IonLabel className='font-weight-normal mb-2'>
                        Select how you want to communicate with {this.props.options?.userAccountType === OCCUPANT_TYPE ? 'tenants' : 'members'}. 
                        You can choose multiple methods.
                </IonLabel>

                {allMessageTypes.map((type) => {
                    return (
                        <FormGroup key={type} className="ml-2 mt-1" check>
                            <Label check>
                                <Input
                                    type="checkbox"
                                    id={`messageType-${type}`}
                                    name={`messageType-${type}`}
                                    checked={this.state.messageTypes.includes(type)}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        this.setState((prevState) => {
                                            let messageTypes = [...prevState.messageTypes];

                                            if (checked) {
                                                // SMS vs WhatsApp mutual exclusion logic
                                                if (type === 'sms') {
                                                    messageTypes = messageTypes.filter(t => t !== 'whatsapp');
                                                }
                                                if (type === 'whatsapp') {
                                                    messageTypes = messageTypes.filter(t => t !== 'sms');
                                                }

                                                if (!messageTypes.includes(type)) {
                                                    messageTypes.push(type);
                                                }
                                            } else {
                                                messageTypes = messageTypes.filter(t => t !== type);
                                            }

                                            return { messageTypes };
                                        });
                                    }}
                                />{' '}
                                {type === 'sms' ? 'SMS' : type === 'email' ? 'Email' : type === 'whatsapp' ? 'WhatsApp' : type}
                            </Label>
                        </FormGroup>
                    );
                })}

                {this.state.messageTypes.length === 0 && (
                    <div style={{ marginTop: "1em" }} className="text-danger">
                        <IonIcon style={{ marginRight: "0.5em" }} icon={alertCircleOutline} />
                        Please select at least one communication method
                    </div>
                )}
            </div>
        );
    }

    renderAccountTypeSettings(){
        return (
            <Col lg={12}>
                <Label for="accountType" className='font-weight-normal ml-2 mb-2'>
                    Select Account/Property Type
                </Label>
                {!_.isEmpty(this.props.options) && _.map(this.props.options.allAccountTypes) && (
                    <Input
                        type="select"
                        name="accountType"
                        id="accountType"
                        onChange={this.handleChange}
                        value={this.state.accountType}
                    >
                        <option value="">Select Account Type...</option>
                        {this.props.options.allAccountTypes.map((accountType, index) => (
                            <option key={index} value={accountType}>{accountType == "property_management"? "Property Management": "Gated Community Management"}</option>
                        ))}
                    </Input>
                )}
            </Col>
        );
    }

    renderCurrencySettings() {
        return (
            <CurrencyDropdown />
        );
    }

    renderTimezoneSettings(){
        return(
            <Timezone />
        );
    }

    render(){
        return (
            <IonPage>
                <IonHeader>
                    <IonToolbar>
                        <IonButtons slot="start">
                            <IonMenuButton />
                        </IonButtons>
                        <IonTitle>General Settings</IonTitle>
                    </IonToolbar>
                </IonHeader>
                { /* START Content */}
                <IonContent>
                    <Card style={{ padding: "1em" }}>
                    <Form onSubmit={this.handleSubmit.bind(this)}>
                        { /* START Input */}
                        <div className="mt-3 ml-2" style={{ fontSize: "1.3em"}} >
                            <h5><strong>Company details</strong></h5>
                            <hr/> <br/>
                        </div>
                        {this.renderCompanySettings()}

                        <Row className='mt-3'>
                            <Col xs={12} sm={6}>
                            <div className="my-3 ml-2" style={{ fontSize: "1.3em"}}>
                                <h5><strong>Currency</strong></h5>
                            </div>
                            <hr/> <br/>
                            {this.renderCurrencySettings()}
                            </Col>

                            <Col xs={12} sm={6}>
                            <div className="my-3 ml-2" style={{ fontSize: "1.3em"}}>
                                <h5><strong>Timezone</strong></h5>
                            </div>
                            <hr/> <br/>
                            {this.renderTimezoneSettings()}
                            </Col>
                        </Row>

                        <div className="mt-4 ml-2" style={{ fontSize: "1.3em"}}>
                            <h5><strong>MPESA</strong></h5>
                        </div>
                        <hr/> <br/>
                        {this.renderMpesaSettings()}

                        <div className="mt-4 ml-2" style={{ fontSize: "1.3em"}}>
                            <h5><strong>Automated Tasks</strong></h5>
                        </div>
                        <hr/> <br/>
                        {this.renderAutomatedTasksSettings()}

                        {this.renderOtherRecurringAutomatedTasksSettings()}

                        {this.renderLandlordAutomatedTasksSettings()}

                        <div className="mt-4 ml-2" style={{ fontSize: "1.3em"}}>
                            <h5><strong>Monthly Payment Reminders</strong></h5>
                        </div>
                        <hr/> <br/>
                        {this.renderSendPaymentRemindersAlerts()}

                        {/* Create a field for lease notifications */}
                        <div className="mt-4 ml-2" style={{ fontSize: "1.3em"}}>
                            <h5><strong>Lease Expiry Notifications</strong></h5>
                        </div>
                        <hr/> <br/>
                        {this.renderSendLeaseExpiryRemindersAlerts()}

                        {/* Communication Options */}
                        <div className="mt-4 ml-2" style={{ fontSize: "1.3em"}}>
                            <h5><strong>Communication Options</strong></h5>
                        </div>
                        <hr/> <br/>
                        {this.renderCommunicationOptions()}

                        {/* select Account Type... either Gated Community or Normal Property */}
                        <div className="mt-4 ml-2" style={{ fontSize: "1.3em"}}>
                            <h5><strong>Account Type</strong></h5>
                        </div> 
                        <hr/> <br/>
                        {this.renderAccountTypeSettings()}

                    </Form>
                    { /* END Form */}
                    </Card>
                </IonContent>
                { /* END Content */}
                <IonFooter className="text-right">
                    <IonToolbar>
                        <IonButtons slot="end">
                            <IonButton
                                type="submit"
                                fill="solid"
                                color="primary"
                                className="mr-5"
                                onClick={this.handleSubmit}
                            >
                                Update Settings
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonFooter>
            </IonPage>
        );
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
) (GeneralSettings);